/** @file Brings a panel to the front, first re-adding its closed tab where the default layout puts it. */
import type { Translate } from '@pose2d/i18n/types';
import type { PanelEntry } from '../panels/panelEntry';
import { applyLayout, type DockTarget } from './applyLayout';

/** A closed tab is added beside its default neighbour (applyLayout's placement); then the panel becomes the active tab. */
export function openPanel(dock: DockTarget, entry: PanelEntry, t: Translate): void {
  applyLayout(dock, null, [entry], t);
  dock.getPanel(entry.id)?.api.setActive();
}
